<div class="start-screen">
  <h3>
    Skill Passport<sup><i style='font-size: 12px' class='fa fa-registered' aria-hidden='true'></i></sup> Setup
  </h3>
  <p>The setup of the Skill Passport<sup><i style='font-size: 8px' class='fa fa-registered' aria-hidden='true'></i></sup> have multiple phases where you will enter your information. </p>
  <p>Please make sure that all your information for this setup are correct.</p>
  <button class="button button-1" (click)="letsStart()">Let's Begin</button>
</div>